module.exports = __webpack_public_path__ + "static/media/Hospitalslide2.79901ad4.webp";